module.exports = __webpack_public_path__ + "img/101.06ee112a.png";